// eslint-disable-next-line import/prefer-default-export
export const partialOverwrite = (dest, overwrite) => {
    Object.entries(overwrite).forEach(([k, v]) => {
        if (
            typeof v === 'object' &&
            v !== null &&
            typeof dest[k] === 'object' &&
            !Array.isArray(dest[k])
        ) {
            partialOverwrite(dest[k], v);
        } else {
            dest[k] = v;
        }
    });
};
